import VueWrapper from '@/components/core/Vue/vue.wrapper';
import axios from 'axios';
import {marked} from 'marked';
import {Component} from 'vue-property-decorator';

@Component
export default class RefundPolicyKrComponent extends VueWrapper {
    public $refs!: {};
    public policyContent: string = '<h3>Loading policy...</h3>'; // Initial loading state

    public async mounted() {
        try {
            // The path is relative to the root of your domain
            const response = await axios.get('/policies/refundPolicyKr.md');

            // The raw markdown text is in response.data
            const markdownText = response.data;

            // Parse and render it
            this.policyContent = await marked.parse(markdownText);
        } catch (error) {
            console.error('Failed to fetch policy:', error);
            this.policyContent = '<p style="color: red;">Error: Could not load the policy content.</p>';
        }
    }
}
